/**
 * The fun ask for LINKED measurement (core USAGE_ASK; owner, 2026-10-08): one card, once, right after a finished check. Two buttons of
 * the same size; the app works the same either way. Profile → Change cookie choices changes it later. Hidden when the build sends no
 * linked analytics, or when a choice (or GPC / Do Not Track) already answers it.
 */
// element: usage-ask (journey: a check just got done; say yes or no to being counted, in one tap)
import { useState } from "react";
import { USAGE_ASK } from "@logwave/core/src/compliance/measure.ts";
import { ANALYTICS_IN_BUILD, readChoice, saveChoice, signals } from "../lib/consent.ts";
import { Button, Card } from "./ui.tsx";
import { useApiMaybe } from "../session.tsx";

export function UsageAskCard({ force, record }: { force?: boolean; record?: (analytics: boolean) => Promise<unknown> }) {
  const api = useApiMaybe();
  const rec = record ?? (api ? (a: boolean) => api.setConsent("usage_data", a) : undefined);
  const [open, setOpen] = useState(() => !!force || (ANALYTICS_IN_BUILD && !readChoice() && !signals().gpc && !signals().dnt));
  if (!open) return null;
  const answer = async (yes: boolean) => { await saveChoice("choose", { analytics: yes }, rec); setOpen(false); };
  return (
    <Card className="stack-sm usage-ask" data-usage-ask>
      <p><strong>{USAGE_ASK.title}</strong></p>
      <p className="small">{USAGE_ASK.body}</p>
      <div className="usage-ask-row">
        <Button variant="secondary" onClick={() => void answer(true)}>{USAGE_ASK.yes}</Button>
        <Button variant="secondary" onClick={() => void answer(false)}>{USAGE_ASK.no}</Button>
      </div>
      <p className="small muted">{USAGE_ASK.after}</p>
    </Card>
  );
}
